import React from "react";
import logo from "../../assets/GP-Logo-1.png";
// import { Link } from "react-router-dom";
function Footer(props) {
  return (
    <div className="flex flex-col md:flex-row justify-between bg-[#01030d] items-center p-10">
      <div className="w-full">
        {" "}
        <div className="flex items-center ">
          <img src={logo} className="w-[70px] md:w-[90px]" alt="" />
          <h1 className="text-white font-black text-xl md:text-2xl">Gele</h1>
        </div>
        <p>8,888 unique Geles who need drivers.</p>
      </div>
      <div className="w-full flex flex-col justify-end">
        <div className="w-1/3">
          <p>Home</p>
          <p>Team</p>
          <p>Terms and Conditions</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
